import React from "react"; // Import CSS file for styling

const CustomCheckBox = ({ checked, onChange, disabled }) => {
  return (
    <label
      className={`custom-checkbox-container ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="custom-checkbox-input"
        disabled={disabled}
      />
      <span className="custom-checkbox-checkmark"></span>
    </label>
  );
};

export default CustomCheckBox;
